module.exports = __webpack_public_path__ + "static/media/Milex-Dish-Pessary-Instructions-for-Use@2x.e43b942c.jpg";